import React from 'react'
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Icons from '../myIcon/Icons';

export default function OfferPopup({ show, onHide, data }) {
    return (
        <>
            <Modal className="offerpopup-area modal-lg" show={show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    <div type="button" className="offerpopup-close" onClick={onHide}>
                        <Icons name="cross" alt="offer" />
                    </div>

                    <div className="row m-0 align-items-center justify-content-center">
                        <div className="col-lg-6 col-md-6 no-padd">
                            <div className="offerpopup-image">
                                <img src={data.leftImage} alt="offer popup"
                                    className="img-responsive offerpopup-desktop-img" />
                                <img src={data.mobileImage} alt="offer" className="img-responsive offerpopup-mobile-img" />
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 no-padd">
                            <div className="offerpopup-text">
                                <label>{data.label}</label>
                                <h1 className="heading">{data.title} <small>{data.highlight}</small></h1>

                                <img src="/image/offerpopup-line-imge.webp" className="img-responsive" alt="offerpopup" />

                                <p>{data.description}</p>

                                {data.showPoints ? (
                                    <>
                                        <div className="offer-benefits">
                                            {data.benefits.slice(0, 3).map((item, index) => (
                                                <div className="benefit-item" key={index}>
                                                    <img src={item.icon} alt={item.text2} />
                                                    <span>{item.text1}</span>
                                                    <p className={item.text2Class || ""}>
                                                        {item.text2}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="offer-points">
                                            {data.benefits.slice(3).map((item, index) => (
                                                <div className="offer-point" key={index}>
                                                    <img src='/image/offer-point-check.webp' alt='check' className='img-responsive' />
                                                    <small dangerouslySetInnerHTML={{ __html: item.text1 }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div className="offer-benefits">
                                        {data.benefits.map((item, index) => (
                                            <div className="benefit-item" key={index}>
                                                <img src={item.icon} alt={item.text2} />
                                                <span dangerouslySetInnerHTML={{ __html: item.text1 }} />
                                                <p className={item.text2Class || ""}>
                                                    {item.text2}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                )}


                                <Link to="/offer-listing" className="default-btn offerarrow-btn color-btn">
                                    <span>Book Direct & Save More</span>
                                    <img src="/image/right-arrow.svg" alt="arrow" />
                                </Link>

                                <div className="maybe-later">
                                    <img src="/image/best-price-guranteed.webp" alt="Best Price Guaranteed" />
                                    <span>Best Price Guaranteed</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}